


















































































import Vue from 'vue'
import FeaturedProject from '@/components/FeaturedProject.vue'
import FooterItem from '@/components/FooterItem.vue'
import HeaderPartners from '@/components/HeaderPartners.vue'
import Services from '@/components/Services.vue'
import Experiences from '@/components/Experiences.vue'
import Location from '@/components/Location.vue'
const carousel = require('v-owl-carousel')

export default Vue.extend({
  name: 'home',
  components: {
    FeaturedProject,
    FooterItem,
    HeaderPartners,
    Services,
    Experiences,
    Location,
    carousel
  },
  data: function () {
    return {
      HeaderPartners: {
        img: {
          src: 'assets/img/partners/veratia/veratia-logo.png',
          alt: 'Izertis es una consultora tecnológica que facilita la transformación digital de las organizaciones'
        },
        name: 'Veratia global services',
        description: '<strong class="font-bold">Veratia Global Services es una empresa consultora TIC, enfocada a las Administraciones Públicas (AAPP) y PYMES</strong> a nivel nacional español y de terceros países, formada por profesionales con más de 15 años de trabajo en el sector y con gran experiencia en proyectos tanto software como hardware y de consultoría en cliente.'
      },
      services: {
        description: 'Consultorías / Proyectos en entidades públicas,  multilaterales, en temáticas diversas, aunque enfocadas a ámbitos funcionales como:',
        services: [
          {
            title: 'Administración y Gobierno Electrónico',
            description: '(gestión de expedientes administrativos, interoperabilidad, datos y gobierno abierto, etc.)'
          },
          {
            title: 'Soluciones transversales',
            description: 'Basadas en Big Data y Analítica de Datos.'
          },
          {
            title: 'Consultorías de clima de negocios  a nivel estatal, nacional',
            description: ''
          },
          {
            title: 'Consultorías de reingeniería y simplificación de procesos administrativos',
            description: ''
          },
          {
            title: 'Soluciones de Comercio Exterior',
            description: ''
          },
          {
            title: 'Smart Cities',
            description: ''
          },
          {
            title: 'Sistemas de Gestión de la Calidad',
            description: ''
          }
        ]
      },
      experiences: {
        experiences: [
          {
            number: '1',
            description: 'Nuestro <strong class="font-bold">enfoque de trabajo es eminentemente sectorial</strong> y basado en nuestro <strong class="font-bold">“expertise” funcional y técnico,</strong> con clientes principalmente de entidades públicas, y en menor medida privadas, en el área principalmente de LATAM y con menor prioridad, en el resto del mundo.'
          },
          {
            number: '2',
            description: 'Propuesta de valor y experiencia contrastada, en fortalecimiento del Sector Público Centroamericano principalmente.'
          },
          {
            number: '3',
            description: '<strong class="font-bold">Presencia comercial en Latinoamérica</strong> (especial foco en México, Guatemala, Nicaragua y Panamá)'
          },
          {
            number: '4',
            description: 'Contamos con gran capacidad de identificación de expertos externos especializados en diferentes áreas de especialización'
          },
          {
            number: '5',
            description: 'Trabajamos activamente en <strong class="font-bold">oportunidades y proyectos relacionados con TIC, promovidos por instituciones multilaterales tipo BID, WB, UE, ONU, etc.</strong>, especialmente en la zona de Latinoamérica, pudiendo aportar nuestra experiencia y metodología en todas las áreas que componen el ciclo de vida de este tipo de proyectos'
          }
        ]
      },
      projects: [
        {
          title: ' BID',
          img: {
            src: 'assets/img/project-2.png',
            alt: ' BID'
          },
          description:
            'Diseño e implementación del sistem integral de gestión de riesgo para la coordinación interninstitcional en los puestos de control de frontera de Nicaragua'
        },
        {
          title: 'UE',
          img: {
            src: 'assets/img/project-1.png',
            alt: 'UE'
          },
          description:
            '089-16 AFSEC – Armonización de los estándares electrotécnicos en África'
        },
        {
          title: 'UE-02',
          img: {
            src: 'assets/img/project-3.png',
            alt: 'UE-02'
          },
          description:
            'EUROPEAID/136799/IH/SER/MULTI, PRAIIA, ASISTENCIA TÉCNICA LOCAL – PLANES PILOTO'
        },
        {
          title: 'UE-02',
          img: {
            src: 'assets/img/project-3.png',
            alt: 'UE-02'
          },
          description:
            'EUROPEAID/136799/IH/SER/MULTI, PRAIIA, ASISTENCIA TÉCNICA LOCAL – PLANES PILOTO'
        }
      ],
      location: {
        url: 'https://www.google.es/maps/@43.5570687,-5.9225635,19z',
        img: {
          src: 'assets/img/maps/veratia-map.png',
          alt: 'Localización de Veratia'
        },
        adress: 'Plaza de Camposagrado nº 1. Planta 3 – Oficina. 1 - 33401 – Avilés – Asturias'
      }
    }
  }
})
